const SUBSCRIPT_MAP: Record<string, string> = {
  '0': '₀',
  '1': '₁',
  '2': '₂',
  '3': '₃',
  '4': '₄',
  '5': '₅',
  '6': '₆',
  '7': '₇',
  '8': '₈',
  '9': '₉',
  a: 'ₐ',
  e: 'ₑ',
  h: 'ₕ',
  i: 'ᵢ',
  j: 'ⱼ',
  k: 'ₖ',
  l: 'ₗ',
  m: 'ₘ',
  n: 'ₙ',
  o: 'ₒ',
  p: 'ₚ',
  r: 'ᵣ',
  s: 'ₛ',
  t: 'ₜ',
  u: 'ᵤ',
  v: 'ᵥ',
  x: 'ₓ',
  '+': '₊',
  '-': '₋',
  '=': '₌',
  '(': '₍',
  ')': '₎',
};

/**
 * Converts a character to its subscript equivalent. If there are excluded subscript characters provided these will not be converted.
 */
export function toSubscript(text: string, exclude = new Set<string>()): string {
  return text
    .split('')
    .map((char) => {
      const subscript = SUBSCRIPT_MAP[char];

      if (subscript && !exclude.has(subscript)) {
        return subscript;
      }

      return char;
    })
    .join('');
}
